module.exports = __webpack_public_path__ + "static/media/logo-saojosebelmonte.7b3bfb5a.png";